// react
import { MouseEvent } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { Contract } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormAddInvoice, FormAddInvoiceProps } from '../../forms/FormAddInvoice/FormAddInvoice';

export interface DialogAddInvoiceProps {
	contract: Partial<Contract> | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: FormAddInvoiceProps['onSuccess'];
}

export const DialogAddInvoice = ({
	contract,
	isOpen,
	onClose,
	onSuccess,
}: DialogAddInvoiceProps) => {
	// hooks
	const { t } = useTranslation();

	if (!contract) {
		return <></>;
	}

	return (
		<DialogActions
			fullScreen={true}
			hasClose={true}
			isOpen={isOpen}
			onClose={(e: MouseEvent<HTMLButtonElement>) => {
				e.preventDefault();
				onClose();
			}}
			subtitle={{
				children: `${t('contract')} ${contract.num}`,
			}}
			title={{ children: t('submitInvoice'), mb: 0 }}
			maxWidth={620}>
			<FormAddInvoice contract={contract} onCancel={onClose} onSuccess={onSuccess} />
		</DialogActions>
	);
};
